import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { decodeURI } from 'utils/helpers/url';
import {
  capitalizeMultiWords,
  capitalizeSingleWord,
  checkStringForDash,
} from 'utils/helpers/format';
import { useMediaQuery } from '@mui/material';
import * as R from 'ramda';
import { useSelector } from 'react-redux';

const useAppTitle = () => {
  const [title, setTitle] = useState('Dashboard');

  const lgUp = useMediaQuery(theme => theme.breakpoints.up('lg'), { noSsr: true });
  const { pathname } = useLocation();

  const mobileDrawerOpen = useSelector(
    state => state.loadingManagement.mobileDrawer.mobileDrawerOpen
  );

  useEffect(() => {
    const moduleType = pathname.split('/')[4];
    const authorizationType = pathname.split('/')[5];
    const subModuleType = pathname.split('/')[6];
    const viewById = pathname.split('/')[7];

    if (!R.isNil(moduleType)) {
      const inventoryTitle =
        lgUp && R.or(R.equals('open', authorizationType), R.equals('search', authorizationType))
          ? checkStringForDash(moduleType)
          : !R.isNil(authorizationType) &&
            R.or(R.equals('open', authorizationType), R.equals('search', authorizationType))
          ? `${capitalizeSingleWord(authorizationType)} Transfer Orders`
          : R.equals('inventory-dashboard', authorizationType) && !lgUp
          ? 'Dashboard'
          : !R.isNil(authorizationType)
          ? checkStringForDash(authorizationType)
          : checkStringForDash(moduleType);

      const mobileTitle =
        !R.isNil(authorizationType) && authorizationType.includes('customer-authorizations')
          ? 'Customer Authorizations'
          : mobileDrawerOpen
          ? decodeURI(viewById || '')
          : R.isNil(authorizationType)
          ? checkStringForDash(moduleType)
          : checkStringForDash(authorizationType);

      const nonInventory =
        !R.isNil(authorizationType) && lgUp
          ? checkStringForDash(authorizationType)
          : !R.isNil(moduleType) && R.isNil(authorizationType) && lgUp
          ? checkStringForDash(moduleType)
          : !lgUp
          ? mobileTitle
          : 'Dashboard';

      if (moduleType.includes('dispatching') && !R.isNil(subModuleType)) {
        const dispatchingTitle = checkStringForDash(subModuleType)
          ? subModuleType.replace(/-/g, ' ')
          : subModuleType;
        const titleHeader =
          authorizationType === 'compliance'
            ? capitalizeMultiWords(dispatchingTitle)
            : capitalizeMultiWords(authorizationType.replace(/-/g, ' '));
        setTitle(titleHeader);
      } else {
        const currentTitle = moduleType.includes('inventory')
          ? inventoryTitle
          : moduleType.includes('swift-plus')
          ? 'Swift+'
          : nonInventory;
        setTitle(currentTitle);
      }
    } else {
      setTitle('Dashboard');
    }
  }, [lgUp, mobileDrawerOpen, pathname]);

  return title;
};

export default useAppTitle;
